__turbopack_context__.v({
  "className": "inter_1e16869b-module__I5ZHZG__className",
  "variable": "inter_1e16869b-module__I5ZHZG__variable",
});
